"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
const styleOverrides = {
  root: {
    marginTop: 17,
    [`&.${_material.stepConnectorClasses.active}, &.${_material.stepConnectorClasses.completed}`]: {
      [`& .${_material.stepConnectorClasses.line}`]: {
        backgroundColor: _constants.colors.primary.main
      }
    }
  },
  alternativeLabel: {
    left: 'calc(-50% + 35px)',
    right: 'calc(50% + 35px)',
    border: 0,
    top: 0
  },
  line: {
    height: 5,
    borderRadius: 5,
    backgroundColor: _constants.colors.oriGrey['200']
  },
  lineHorizontal: {
    borderTopStyle: 'none'
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiStepConnector.js.map